import { useAnalyticsEvent } from "@unlikelystudio/react-ecommerce-hooks"

import type { CustomEvents } from "~/hooks/tracking/useEmitCustomAnalyticsEvent/types"

type UseCustomAnalyticsEventParams<CustomEvent extends keyof CustomEvents> = Pick<
  Parameters<typeof useAnalyticsEvent>[0],
  "canProcessEvent"
> & {
  type: CustomEvent
  callback: (event: CustomEvents[CustomEvent]) => void
}

export function useCustomAnalyticsEvent<CustomEvent extends keyof CustomEvents>({
  type,
  canProcessEvent,
  callback,
}: UseCustomAnalyticsEventParams<CustomEvent>) {
  // TODO: improve abstracts with custom types
  // @ts-expect-error
  useAnalyticsEvent<CustomEvent>({
    type,
    canProcessEvent,
    callback,
  })
}
